// src/components/Fields/TextFieldPreview.jsx
import React, { useContext } from 'react';
import { Typography, Box } from '@mui/material';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import DraggablePreviewWrapper from './DraggablePreviewWrapper';  // Ensure the path is correct
import { useFormLayout } from '../../contexts/FormLayoutContext'; // Adjust path as necessary

const TextFieldPreview = ({ id, index }) => {
    const { showDropZones, setShowDropZones } = useFormLayout();  // Use context to manage showDropZones

    // Check if the function is callable (this is more for verification and should not be used in production)
    try {
        setShowDropZones && setShowDropZones.toString(); // This will log the function's definition if it's a function
//        console.log(`[TextFieldPreview] setShowDropZones function definition:`, setShowDropZones.toString());
    } catch (error) {
        console.error("[TextFieldPreview] Error logging setShowDropZones function definition:", error);
    }

    // Render component with setShowDropZones passed to DraggablePreviewWrapper
    return (
        <DraggablePreviewWrapper
            id={id}
            type="textField"
            index={index}
            isNew={true}
            showDropZones={showDropZones} // Pass down showDropZones state
            setShowDropZones={setShowDropZones} // Pass down setShowDropZones function
        >
            <Box display="flex" alignItems="center">
            <TextFieldsIcon sx={{ fontSize: '0.95rem', marginRight: '8px', color: '#455A64' }} />
                <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}>
                    Text Field
                </Typography>
            </Box>

        </DraggablePreviewWrapper>
    );
};

export default TextFieldPreview;
